import { Typography, Skeleton, Box } from '@mui/material'
import { memo } from 'react'
import type { TEnumItem } from '@modules/types'
import { getEnumNameById } from '@modules/api-core'
import { getCurrencySymbol } from '@screens/requests/components/PublisherRequest/common/feeDisplayUtils'

interface PriceDisplayProps {
  price: number
  color: string
  currency: string
  initialLoading?: boolean
  counterOfferInfo?: { initialFee: number; proposedFee: number; currencyId: number } | null
  enums?: TEnumItem[]
  validationError?: string
}

export const PriceDisplay = memo(
  ({
    price,
    color,
    currency,
    initialLoading,
    counterOfferInfo,
    enums,
    validationError,
  }: PriceDisplayProps) => {
    if (initialLoading) {
      return <Skeleton variant="text" width={80} height={32} />
    }

    const getCounterOfferCurrencySymbol = (currencyId: number): string => {
      if (!enums) return '$'

      const currencyName = getEnumNameById(enums, 'request_currency', currencyId)
      return getCurrencySymbol(currencyName)
    }

    const displayText = counterOfferInfo
      ? `${getCounterOfferCurrencySymbol(counterOfferInfo.currencyId)}${counterOfferInfo.initialFee} (${getCounterOfferCurrencySymbol(counterOfferInfo.currencyId)}${counterOfferInfo.proposedFee} counteroffer)`
      : `${currency}${price}`

    return (
      <Box sx={{ position: 'relative', minHeight: '32px' }}>
        <Typography variant="h5" fontWeight={600} color={validationError ? 'error.main' : color}>
          {displayText}
        </Typography>
        {validationError && (
          <Typography
            variant="caption"
            color="error.main"
            sx={{
              fontSize: '0.75rem',
              position: 'absolute',
              top: '100%',
              left: 0,
              whiteSpace: 'nowrap',
              maxWidth: '200px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {validationError}
          </Typography>
        )}
      </Box>
    )
  },
)
